import {
    EDITCHARGEMASTER_SUCCESS,
    EDITCHARGEMASTER_FAILED,
    RESET_EDITCHARGEMASTER,
    LOADING_EDITCHARGEMASTER,
    NETWORK_ERROR_EDITCHARGEMASTER
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetEditChargeMaster = () => {
    return { type: RESET_EDITCHARGEMASTER };
};

const editChargeMaster = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_EDITCHARGEMASTER });
    await partnerServices
        .post("updateChargeMaster", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(editChargeMastersuccess(res.data));
                    break;
                default:
                    dispatch(editChargeMasterFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_EDITCHARGEMASTER,
                payload: err
            });
        });
};
function editChargeMastersuccess(data) {
    return {
        type: EDITCHARGEMASTER_SUCCESS,
        payload: data
    };
}
function editChargeMasterFailed(data) {
    return {
        type: EDITCHARGEMASTER_FAILED,
        payload: data
    };
}

export { resetEditChargeMaster, editChargeMaster };
